import { authAxiosClient } from '@/lib';
import { PaginatedApiResponse, PaginatedData } from '@/types';
import { omit, withLogger } from '@/utils';

import { usersAPIUrls } from '../data';
import { User } from '../types';
import { EditUserForm } from '../hooks';

type Param = {
  userId: string;
};

type Response = {
  message: string;
  data: User;
};

export type GetUser = {
  param: Param;
  return: EditUserForm;
};

export const getUser = withLogger(
  async ({ userId }: Param): Promise<GetUser['return']> => {
    const url = `${usersAPIUrls.getUser}/${userId}`;

    const { data } = await authAxiosClient.get<Response>(url);

    const transformedData = responseMiddleware(data);

    return transformedData;
  },
);

const responseMiddleware = ({ data }: Response): GetUser['return'] => {
  return omit(
    {
      ...data,
    },
    ['createdAt', 'updatedAt', 'deletedAt'],
  );
};
